import { generatePath, useNavigate, useParams } from "react-router-dom";
import routes from "@/constants/routes";
import get from "lodash/get";

const useRoutes = () => {
  const navigate = useNavigate();
  const { organizationAlias, organizationId } = useParams();

  const getUrl = (url: string, params: Record<string, string> = {}): string => {
    const _params = { ...params };
    const _url = get(routes, url);
    const requiresOrganizationId = _url.includes(":organizationId");
    const requiresOrganizationAlias = _url.includes(":organizationAlias");

    if (requiresOrganizationId && organizationId) {
      _params.organizationId = organizationId;
    }

    if (requiresOrganizationAlias && organizationAlias) {
      _params.organizationAlias = organizationAlias;
    }

    return generatePath(_url, _params) + document.location.search;
  };

  const goToUrl = (url: string, params: Record<string, string> = {}) => {
    navigate(getUrl(url, params));
  };

  return [goToUrl, getUrl];
};

export default useRoutes;